import { StyleSheet, Platform, Dimensions } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  container: (theme, isLastPermission) => ({
    backgroundColor: Colors.transparent,
    ...(!isLastPermission
      ? {
        borderBottomColor: theme.colors.VFDivider.primary,
        borderBottomWidth: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 0 : 1,
      }
      : {}),
    marginEnd: 20,
    paddingBottom: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 8 : 8,
    paddingTop: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 8 : 8,
    overflow: 'hidden',
  }),
  headerContainer: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  title: {
    flex: 1,
    fontFamily: Fonts.type.VFFont,
    fontSize: 18.7,
    lineHeight: 25,
    marginStart: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 16 : 8,
    marginTop: Platform.OS === 'ios' ? 3 : 0,
    fontWeight: 700
  },
  description: theme => ({
    color: theme.colors.textColorTwo,
    fontSize: 14.6,
    lineHeight: 18.7,
    marginStart: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 16 : 42,
    marginEnd: 60,
    marginTop: 5,
  }),
  toggleAsText: theme => ({
    fontSize: 16,
    marginTop: 5,
    lineHeight: 24,
    fontFamily: Fonts.type.VFFont,
    color: theme.colors.headerColor,
    marginHorizontal: 5,
  }),
  toggle: {
    marginVertical: 0,
  },
});
